import React, { useEffect } from "react";
import { Box, Container, Typography, Grid, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { motion } from "framer-motion";
import heroBg from "../assets/downloaded/test.png";

// Import client logos (reusing from landing page)
import comelec from "../assets/nextix/comelec.jpg";
import dbm from "../assets/nextix/dbm.jpg";
import lto from "../assets/nextix/lto.jpg";
import intellicare from "../assets/nextix/intellicare-2.jpg";
import mitsubishi from "../assets/nextix/mitsubishi-motors-2.jpg";
import toyota from "../assets/nextix/toyota-logo.jpg";
import jollibee from "../assets/nextix/jollibee-logo.jpg";
import aboitiz from "../assets/nextix/aboitizland-logo.jpg";
import pldtClient from "../assets/downloaded/p-pldt-logo-300x150.jpg";
import pnb from "../assets/nextix/pnb-logo.jpg";
import lufthansa from "../assets/nextix/lufthansatechnik-logo.jpg";
// Additional logos
import twoGo from "../assets/downloaded/2go-logo.jpg";
import talk51 from "../assets/downloaded/51-talk-logo.jpg";
import abenson from "../assets/downloaded/abenson-logo.jpg";
import aviva from "../assets/downloaded/aviva-logo.jpg";
import dswd from "../assets/downloaded/dswd-logo.jpg";
import dti from "../assets/downloaded/dti-logo.jpg";
import fortunecare from "../assets/downloaded/fortunecare-logo.jpg";
import kfc from "../assets/downloaded/kfc-logo.jpg";
import maxicare from "../assets/downloaded/maxicare-logo.jpg";
import oceanic from "../assets/downloaded/oceanic-logo.jpg";
import philgeps from "../assets/downloaded/client-philgeps.jpg";
import psa from "../assets/downloaded/clients-psa.jpg";
import pnp from "../assets/downloaded/client-pnp.jpg";
import philvocs from "../assets/downloaded/client-philvocs.jpg";
import alphadent from "../assets/downloaded/alphadent-logo.jpg";
import dimsum from "../assets/downloaded/dimsumbreak-logo.jpg";
import doubleDragon from "../assets/downloaded/double-dragon-logo.jpg";
import eton from "../assets/downloaded/eton-logo.jpg";
import faithAcademy from "../assets/downloaded/faithacademy-logo.jpg";

const awards = [
  { year: "2019", award: "AWARDS RECEIVED", title: "A Special Commendation of the Red Herring Asia's Top 100 Startups. Manila, Philippines" },
  { year: "2015", award: "BEST VALUE AWARD", title: "Best Value Award in National Science and Technology Week Exhibit. Philippines *" },
  { year: "2011", award: "PEOPLE CHOICE AWARD", title: "People\'s Choice Award for IT-BPO. Singapore. *" },
  { year: "2010", award: "3rd PLACE NON-CONSUMER IOT DEVICE CALL CENTER GRADE", title: "3rd Place Non-Consumer IoT Device Call Center Grade. Singapore *" },
  { year: "2009", award: "3RD PLACE TECHNOLOGY CITY", title: "3rd Place in Technology City Exposition at Cebu V.I.P. Exhibit. Philippines" },
  { year: "2009", award: "BEST EXHIBIT", title: "3rd Place in National Invention Contest and Exposition at SMX, Manila, Philippines" },
  { year: "2008", award: "DIGITAL STAR AWARD WINNER", title: "Digital Star Award Winner Recipient Golden Awards Cebu. Philippines. USA *" },
  { year: "2007", award: "A FINALIST UN INFORMATION TECHNOLOGY AT THE WORLD SUMMIT ON INFORMATION SOCIETY", title: "A finalist UN Information Technology at the World Summit on Information Society Award. Geneva, Switzerland *" },
  { year: "2006", award: "A SPECIAL COMMENDATION TECHNOLOGY AWARD (AT T)", title: "A Special Commendation Technology Award (AT\u0026T). Manila, Philippines" }
];

const WhoWeAreScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const clientLogos = [
    toyota, pnb, jollibee, aboitiz, lufthansa, intellicare,
    dbm, lto, comelec, mitsubishi, pldtClient,
    twoGo, talk51, abenson, aviva, dswd, dti,
    fortunecare, kfc, maxicare, oceanic, philgeps, psa,
    pnp, philvocs, alphadent, dimsum, doubleDragon, eton, faithAcademy
  ];

  return (
    <Box sx={{ backgroundColor: "#fff" }}>

      {/* HERO SECTION - Simplified */}
      <Box sx={{
        position: "relative",
        py: { xs: 10, md: 10 },
        backgroundImage: `url(${heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        backgroundAttachment: "local",
        textAlign: "center"
      }}>
        <Box sx={{
          position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.07)"
        }} />

        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography variant="h3" sx={{
              color: "white",
              fontWeight: 300,
              mb: 3,
              fontSize: { xs: "2rem", md: "3rem" }
            }}>
              Building Digital Innovations
            </Typography>
            <Box sx={{
              maxWidth: "99%",
              height: "2px",
              backgroundColor: "white",
              mx: "auto",
              mb: 3
            }} />
            <Typography variant="h6" sx={{
              color: "white",
              fontWeight: 300,
              lineHeight: 1.6,
              fontSize: { xs: "1rem", md: "1.4rem" }
            }}>
              NEXTIX is an organization aligned around social innovation. We find practical solutions to social problems.
            </Typography>
          </motion.div>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>

        {/* OUR COMPANY */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
            Our Company
          </Typography>
          <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 3, textAlign: "start" }}>
            NEXTIX is an award winning technology company focused on next generation positive impact digital platforms. NEXTIX specializes on creating customer driven innovations with universally available information and communication technology solutions that constantly aims to drive technology to the next level with robust, scalable & agile systems, creating infinite feature rich applications.
            The company's expertise creates a more agile and multi-faceted technology innovations and solutions. Our goal is to provide enhanced business through a combination of consultation, support and innovative products and services, and create competitiveness for our clients in an ever-changing business environment.
          </Typography>
        </motion.div>


        {/* OUR HISTORY */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
            Our History
          </Typography>
          <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 2, textAlign: "start" }}>
            NEXTIX started in 2005 during the early days of the Business Process Outsourcing industry in the Philippines. The company is one of the pioneers in providing telecommunication systems and engineering services for the booming international & local call center industry with significant success. Because of customer demand, NEXTIX built and deployed several software innovations focused on enterprise & government clients from Singapore, China, South Korea, France, Switzerland, and the US. In the process, NEXTIX accumulated multiple local & international technology awards from the Philippines, Singapore, and the US.
          </Typography>
          <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, textAlign: "start", mb: 3 }}>
            NEXTIX businesses now include identity, cloud, fintech, authentication and digital infrastructure. NEXTIX currently operates in the Philippines, South Korea, China, India, Switzerland and the US.
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: "#375ca8", textAlign: "start" }}>
            Our Mission
          </Typography>
          <Typography sx={{ color: "#666", lineHeight: 1.8, textAlign: "start", mb: 3 }}>
            To improve lives by accelerating social and economic development with trusted platforms.
          </Typography>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: "#375ca8", textAlign: "start" }}>
            Our Vision
          </Typography>
          <Typography sx={{ color: "#666", lineHeight: 1.8, textAlign: "start", mb: 3 }}>
            To be the leading Social Innovation Platform.
          </Typography>
        </motion.div>



        {/* AWARDS SECTION */}
        <Box id="awards" sx={{ mt: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 300, mb: 0, color: "#1c1c1c" }}>
              next|ix Awards
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2" sx={{ textAlign: "center", color: "#666", mb: 6 }}>
              ENTERPRISE AND GOVERNMENT
            </Typography>

            <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e0e0e0" }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: "bold", color: "#1c1c1c", width: "100px" }}>YEAR</TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#1c1c1c" }}>AWARDS RECOGNITION</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {awards.map((award, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:hover": { backgroundColor: "#fafafa" },
                        borderBottom: "1px solid #e0e0e0"
                      }}
                    >
                      <TableCell sx={{ color: "#666", verticalAlign: "top", pt: 2 }}>{award.year}</TableCell>
                      <TableCell sx={{ color: "#666", py: 2 }}>
                        <Typography variant="body2" sx={{ fontWeight: "600", color: "#1c1c1c", mb: 0.5 }}>
                          {award.award}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          {award.title}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Typography variant="caption" sx={{ display: "block", mt: 2, color: "#999", fontStyle: "italic" }}>
              * International Award
            </Typography>
          </motion.div>
        </Box>


        {/* OUR CLIENTS SECTION */}
        <Box sx={{ mt: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Typography variant="h4" sx={{ textAlign: "center", fontWeight: 300, mb: 0, color: "#1c1c1c" }}>
              Our Clients
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2" sx={{ textAlign: "center", color: "#666", mb: 6 }}>
              ENTERPRISE AND GOVERNMENT
            </Typography>
          </motion.div>

          <Grid container spacing={4} justifyContent="center" alignItems="center">
            {clientLogos.map((logo, index) => (
              <Grid item xs={6} sm={4} md={2.4} key={index} component={motion.div}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="client logo"
                  sx={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "150px",
                    display: "block",
                    mx: "auto",
                    filter: "grayscale(0%)",
                    transition: "all 0.3s",
                    "&:hover": { filter: "grayscale(100%)" }
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

      </Container>

    </Box>
  );
};

export default WhoWeAreScreen;
